import { render } from "./PatientInformationAdd.vue?vue&type=template&id=165c0228"
import script from "./PatientInformationAdd.vue?vue&type=script&lang=js"
export * from "./PatientInformationAdd.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sendOuts/PatientInformationAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "165c0228"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('165c0228', __exports__)) {
    console.log('reload')
    api.reload('165c0228', __exports__)
  }
  
  module.hot.accept("./PatientInformationAdd.vue?vue&type=template&id=165c0228", () => {
    console.log('re-render')
    api.rerender('165c0228', render)
  })

}


export default __exports__